
<script setup>

  import { ref } from 'vue';

  import { TransitionRoot, TransitionChild, Dialog, DialogPanel, DialogTitle } from '@headlessui/vue';

  import { XCircleIcon } from '@heroicons/vue/24/outline';

  import FitContainer from '../components/fit-container.vue';

  import BookPage from '../components/book-page.vue';

  import pagePaths from '../green-book/*.jpg';

  import excerptsPDFPath from '../pdfs/green-book-1940-excerpts.pdf';

  const pages = Object.values( pagePaths ).sort();

  const pageCount = pages.length;

  const paperCount = pageCount / 2;

  const paper = ref( 0 );

  const isOpen = ref( false );

  function open() {
    
    isOpen.value = true;

    setTimeout( () => paper.value = 1, 250 );

  }

  function close() {
    
    isOpen.value = false;

    paper.value = 0;

  }

  function onClick( event ) {

    if ( Math.round( event.x / window.innerWidth ) )
    
      paper.value = paper.value + 1 > paperCount ? paperCount : paper.value + 1;

    else paper.value = paper.value - 1 < 0 ? 0 : paper.value - 1;

  }

  defineExpose( { open, close } );

</script>

<template>

  <TransitionRoot appear :show="isOpen" as="template">

    <Dialog as="div" @close="close" class="fixed inset-0 overflow-hidden z-20 drop-shadow-[0_0_15px_rgba(0,0,0,0.5)]">

      <div class="absolute inset-x-0 bottom-0 overflow-hidden">

        <TransitionChild

          as="template"

          enter="transition transform duration-300 ease-out"

          enter-from="translate-y-full"

          enter-to="translate-y-0"

          leave="transition transform duration-200 ease-in"

          leave-from="translate-y-0"

          leave-to="translate-y-full">

          <DialogPanel class="w-screen h-screen overflow-hidden bg-white">
            
            <div class="flex items-center justify-between gap-5 px-5 h-[80px]">

              <DialogTitle as="h3" class="text-2xl md:text-4xl font-heading uppercase">

                The Green Book

              </DialogTitle>

              <div class="sr-only">

                Read accessible excerpts from the Green Book as a PDF:

                <a :href="excerptsPDFPath" target="_blank">Green Book 1940 Exceprts (PDF)</a>.

              </div>

              <div class="hidden md:block italic text-sm" aria-hidden="true">Click or touch to turn the pages.</div>

              <button type="button" @click="close" class="group flex items-center gap-2">

                <div class="text-sm group-focus-visible:underline group-hover:underline">Close</div>

                <XCircleIcon class="w-8" />
              
              </button>

            </div>

            <div class="md:hidden h-[calc(100vh-80px)] p-6 overflow-y-scroll" aria-hidden="true">

              <template v-for="( path, index ) in pages">

                <img :src="path" alt=""
                
                  :class="[ 'w-full', { 'mt-6': index > 0 } ]"
                  
                  v-if="index !== 1 && index !== pageCount - 2" />

              </template>

            </div>

            <div class="hidden md:flex items-center justify-center h-[calc(100vh-80px)]" @click="onClick" aria-hidden="true">

              <FitContainer :width="1074" :height="771" fit="contain" class="relative w-full h-full">

                <div class="w-full h-full p-12">

                  <div class="relative w-full h-full drop-shadow-[0_0_15px_rgba(0,0,0,0.5)]" style="perspective: 3000px">

                    <BookPage v-for="number in paperCount"

                      :index="number - 1" :paper="paper"

                      :front="pages[ ( number - 1 ) * 2 ]"
                      
                      :back="pages[ ( number - 1 ) * 2 + 1 ]"
                      
                      :flip="number - 1 < paper" />

                  </div>

                </div>

              </FitContainer>

            </div>

          </DialogPanel>

        </TransitionChild>

      </div>

    </Dialog>

  </TransitionRoot>

</template>
